import { useElitePlansLanding } from '../ElitePlansLandingContext'
import { ELITE_PRIME_DASHBOARD_BADGE } from '../constants/copy'
import { ElitePlansHeroCurve } from '../icons/ElitePlansHeroCurve'
import {
  ElitePlansHeroEmblem,
  ElitePlansHeroBadge,
  ElitePlansHeroHeadline
} from './hero/ElitePlansHeroHeading'
import { ElitePlansMembershipPlanCard } from './ElitePlansMembershipPlanCard'
import { NewEliteDashboardHeadCardSkeleton } from '../../new-elite-landing/components/NewEliteDashboardHeadCardSkeleton'

export function ElitePrimeDashboardHero() {
  const { activeTab, status, isStatusLoading } = useElitePlansLanding()
  const hero = activeTab.hero
  const pricingDetailsTemplate = activeTab.plusBanner?.pricingDetails

  return (
    <section className='relative text-center'>
      <div className='ep-page-bg ep-theme-tween w-full'>
        <div className='relative mx-auto flex max-w-[720px] flex-col items-center px-5 pb-8'>
          <ElitePlansHeroEmblem
            riveSrc={hero.emblemRiveSrc}
            fallbackSrc={hero.emblemSrc}
            alt={hero.emblemAlt ?? ''}
          />
          <ElitePlansHeroBadge className='text-[color:var(--ep-ink-muted)]'>
            {ELITE_PRIME_DASHBOARD_BADGE}
          </ElitePlansHeroBadge>
          <ElitePlansHeroHeadline headlineSans={hero.headlineSans} headlineSerif={hero.headlineSerif} />

          {isStatusLoading ? (
            <div className='mt-8 w-full'>
              <NewEliteDashboardHeadCardSkeleton />
            </div>
          ) : (
            <ElitePlansMembershipPlanCard
              eliteOnboardingStatus={status}
              pricingDetailsTemplate={pricingDetailsTemplate}
              planNamePrefix='Prime'
              className='mt-8 w-full'
            />
          )}
        </div>

        <ElitePlansHeroCurve themeId={activeTab.themeId} />
      </div>
    </section>
  )
}
